<div class="prompt">
  <div class="prompt-header">Run brand research for “{{ data.brandName }}”?</div>

  <p class="prompt-description">
    Brand research uses AI + web search to build the brand's profile — category, size and budget
    assumptions per country and channel. <strong>Social metrics are estimated on top of this profile,
    so without research the brand shows no social data.</strong>
  </p>
  <p class="prompt-description">
    The scheduled research covers all brands once a month; running it now means this brand gets data
    today instead of waiting for the next cycle. It starts within ~10 minutes, and estimates will be
    possible for dates from <strong>{{ estimatesFrom }}</strong> onward (30 days back — for a custom
    date, use Edit brand → Research → Run…).
  </p>

  <div class="prompt-error" *ngIf="error() as message">{{ message }}</div>

  <div class="prompt-buttons">
    <app-button text="Not now" [class]="triggering() ? 'cancel disabled' : 'cancel'" (clicked)="notNow()"></app-button>
    <app-button [text]="triggering() ? 'Queuing…' : 'Run research'"
      [class]="triggering() ? 'primary disabled' : 'primary'" (clicked)="run()"></app-button>
  </div>
</div>
